import { normalizeTerm } from "./search-utils";

const HANGUL_BASE_CODE = 0xac00;
const HANGUL_LAST_CODE = 0xd7a3;
const HANGUL_INITIALS = [
  "\u{3131}",
  "\u{3132}",
  "\u{3134}",
  "\u{3137}",
  "\u{3138}",
  "\u{3139}",
  "\u{3141}",
  "\u{3142}",
  "\u{3143}",
  "\u{3145}",
  "\u{3146}",
  "\u{3147}",
  "\u{3148}",
  "\u{3149}",
  "\u{314a}",
  "\u{314b}",
  "\u{314c}",
  "\u{314d}",
  "\u{314e}",
];

export const uniqueTerms = (terms) => {
  const seen = new Set();
  return terms
    .map(normalizeTerm)
    .filter((term) => {
      if (!term) return false;
      const key = term.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

const getHangulInitials = (value) =>
  String(value || "")
    .split("")
    .map((char) => {
      const code = char.charCodeAt(0);
      if (code < HANGUL_BASE_CODE || code > HANGUL_LAST_CODE) return char;
      const initialIndex = Math.floor((code - HANGUL_BASE_CODE) / 588);
      return HANGUL_INITIALS[initialIndex] || char;
    })
    .join("");

export const matchesSearchTerm = (term, query) => {
  const normalizedTerm = normalizeTerm(term).toLowerCase();
  const normalizedQuery = normalizeTerm(query).toLowerCase();
  if (!normalizedQuery) return true;
  if (normalizedTerm.includes(normalizedQuery)) return true;
  return getHangulInitials(normalizedTerm).includes(normalizedQuery);
};
